<template>
    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="text__align-center text__colour-white layout__margin__bottom-25px layout__position__relative">
                    <div class="layout__padding-clear layout__width-50 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                        <h2 class="text__colour-teal">My Account</h2>
                        <div class="layout__padding-20-0 text__size-18 text__colour-grey">Monitor your account activity
                            here. Track your orders and monitor branch-level month-by-month spending.
                        </div>
                    </div>

                  <router-link to="/directmailr" class="link__colour-teal">
                    <el-button class="button__background-tickled-pink button__promo account preserve-bg">
                      <h3 class="mb-0">
                        20/20 campaigns <br><br>
                        from just £22.80
                      </h3>
                    </el-button>
                  </router-link>
                </div>
                <div class="layout__margin-20-0">
                    <div class="component__columns-2 layout__border__all-1px-grey">
                        <div class="layout__padding-30px">
                            <div class="text__size-18 text__colour-teal">Last 5 Orders</div>
                            <div v-if="lastOrders.length > 0">
                            <span v-for="order in lastOrders">
                    <div class="layout__border__bottom layout__padding-25-0 text__size-14">
                        <span class="layout__position-left layout__width-60 text__truncate">
                            {{order.jobName}}
                        </span>
                        <span class="layout__width-25 layout__position-left">{{formatOrderSource(order)}}
                        </span>
                        <span class="layout__width-15 text__colour-teal link__colour-teal layout__cursor-pointer layout__position-left text__align-right"
                           v-on:click="viewOrder(order)">details
                        </span>

                    </div>
                </span>
                            <el-button class="button__base button-red layout__margin-20-0 layout__width-200px layout__position-right"
                                       v-on:click="goToAllOrders()">
                                View All Orders
                            </el-button>
                            </div>
                            <div v-else class="layout__padding-20-0">
                                <p class="text__colour-red">No order history available</p>
                            </div>
                        </div>
                    </div>
                    <div class="component__columns-2 layout__border__all-1px-grey">
                        <div class="layout__padding-30px">
                            <div class="text__size-18 text__colour-teal">Spending Review</div>
                            <div class="layout__width-50 layout__padding-25-0 layout__position-left text__size-14__no-preline">
                                <div class="layout__border__bottom layout__margin__bottom-10 layout__padding-8-0">
                                    Marketing
                                    Toolkit<span
                                        class="text__align-right layout__position-right">£{{this.spend.toolkit}}</span>
                                </div>
                                <div class="layout__border__bottom layout__margin__bottom-10 layout__padding-8-0">
                                    Photofixr&trade;<span
                                        class="text__align-right layout__position-right">£{{this.spend.photofixr}}</span>
                                </div>
                                <div class="layout__border__bottom layout__margin__bottom-10 layout__padding-8-0">
                                    Instant
                                    Print<span
                                        class="text__align-right layout__position-right">£{{this.spend.instantprint}}</span>
                                </div>
                                <div class="layout__border__bottom layout__margin__bottom-10 layout__padding-8-0">
                                    Bespoke<span
                                        class="text__align-right layout__position-right">£{{this.spend.bespoke}}</span>
                                </div>
                                <div class="layout__border__bottom layout__margin__bottom-10 layout__padding-8-0">Orders
                                    via
                                    Email<span
                                            class="text__align-right layout__position-right">£{{this.spend.email}}</span>
                                </div>
                                <div class="layout__border__bottom layout__margin__bottom-10 layout__padding-8-0">Delivery<span
                                            class="text__align-right layout__position-right">£{{this.spend.delivery}}</span>
                                </div>
                                <div class="layout__margin__bottom-10 layout__padding-8-0">Total Spend (excludes VAT)<span
                                            class="text__align-right layout__position-right">£{{this.spend.total}}</span>
                                </div>
                            </div>
                            <div class="layout__width-40 layout__padding-25-0 layout__position-right">
                                <el-input-number v-model="year" :min="1990" :max="2029"
                                                 v-on:change="constructMonthSummary()"></el-input-number>
                                <div class="layout__padding-clear">
                                    <div class="layout__padding-10px-0">
                                        <el-radio-group v-model="selectedMonth" v-for="(mon, index) in months" :max="1" class="" v-on:change="constructMonthSummary">
                                            <el-radio-button class="layout__width-40px layout__border__all-2px-f4f4f4 layout__padding-10-0" :label="index" :key="'index'">{{mon.name}}</el-radio-button>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout__padding-clear layout__width-100">
                    <div class="">
                        <div class="component__columns-3__no-padding layout__border__all-1px-grey layout__margin-30-0 layout__margin__right-20px layout__padding__top-25px layout__padding__bottom-25px layout__height-100px">
                            <div class="layout__width-100 layout__position-left text__align-center">
                                <div class="text__colour-teal text__size-18 layout__margin__bottom-25px">Your Ravensworth Branch Code
                                </div>
                                <div class="text__size-20 layout__margin__bottom-25px text__style-bold-900 text__colour-black">{{this.branchCode}}
                                </div>
                            </div>
                        </div>
                        <div class="component__columns-3__no-padding layout__border__all-1px-grey layout__margin-30-0 layout__margin__right-20px layout__padding__top-25px layout__padding__bottom-25px layout__cursor-pointer layout__height-100px"
                             v-on:click="routeBillingAddress()">
                            <div class="layout__width-40 layout__position-left">
                                <div class="layout__padding-0-20">
                                    <img class="layout__width-100px layout__position-center" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/debit-card.svg">
                                </div>
                            </div>
                            <div class="layout__width-60 layout__position-left">
                                <div class="text__colour-teal text__size-18 layout__margin__bottom-25px">Billing Address
                                </div>
                                <p>View and Update your billing address here</p>
                            </div>
                        </div>
                        <div class="component__columns-3__no-padding layout__border__all-1px-grey layout__margin-30-0 layout__margin__right-20px layout__padding__top-25px layout__padding__bottom-25px layout__cursor-pointer layout__height-100px"
                             v-on:click="routePassword()">
                            <div class="layout__width-40 layout__position-left">
                                <div class="layout__padding-0-20 ">
                                    <img class="layout__width-100px layout__position-center" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/login-security.svg">
                                </div>
                            </div>
                            <div class="layout__width-60 layout__position-left">
                                <div class="text__colour-teal text__size-18 layout__margin__bottom-25px">Login &
                                    Security
                                </div>
                                <p>Update your login details, reset your password here</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="layout__display-none layout__margin__bottom-25px" id="message">
                    <div class="rifat-test-transition">
                        <div class="">
                            <div class="layout__position-right text__align-right el-icon-close text__size-24 layout__cursor-pointer"
                                v-on:click="closeMessage()"></div>
                            <div class="layout__position-left">
                                <h3 class="layout__margin__top-10 text__colour-red">RAVENSWORTH UPDATE</h3>
                                <br>
                                <div class="">
                                    <p class="layout__padding-5 text__colour-grey layout__padding-clear text__size-16">Having supplied print and marketing services to the Property Industry for almost 50 years Ravensworth would like to thank their loyal customers for their business over that period.
                                        <br><br>
                                        During that time the way Property professionals use printed products has dramatically changed.
                                        <br><br>
                                        As a result of the decline in the demand for print, Ravensworth and Print Concern have joined forces with effect from February 2026.
                                        <br><br>
                                        Like Ravensworth, Print Concern has been one of the market leaders in print to the property market since the nineties, with a deep understanding and strength in data and print, including working with I AM PROPERTIES.
                                        <br><br>
                                        From February 2026 all print will be carried out in the dedicated print operation in Oxford, where Print Concern has recently installed the latest digital print technology to ensure the ultimate print quality for customers. As a Ravensworth customer, you will continue to place and process orders in the same way you do today.
                                        <br><br>
                                        Together with taking advantage of the latest print technology in Oxford, we will also now be able to extend the cut-off time for next day despatch to 6pm for all standard products.
                                        <br><br>
                                        Delivery times won’t change as all orders will continue to be delivered by DX.
                                        <br><br>
                                        As from February 2026 all orders will be invoiced by Print Concern and customers will be asked to set up a direct debit to simplify payment of all invoices. Details on this will follow shortly.
                                        <br><br>
                                        Supporting customers will remain a key feature of the business and from February 2026 RAVENSWORTH/PRINT CONCERN will continue to achieve this through a dedicated customer service team headed up by Jackie in Oxford, 01865 712211 Email orders@printconcern.co.uk. Not to mention the very hands-on Tim Underwood (MD) who is contactable by email at Timprint@icloud.com.</p>
                                </div>

                                <el-button
                                    class="button__base button-teal layout__display-block text__align-center layout__cursor-pointer layout__margin-20-0"
                                    style="margin: 20px auto;"
                                    v-on:click="closeMessage()">OK
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Axios from 'axios';
    import Router from '../../router';

    Vue.use(Element);

    export default {
        name: "start",
        mixins: [axios, dataFormatter],
        data() {
            return {
                // timer: ''
                dataexample: '',
                year: '',
                topOrders: 5,
                selectedMonth: new Date().getMonth(),
                months: [
                    {id: 0, name: 'Jan'},
                    {id: 1, name: 'Feb'},
                    {id: 2, name: 'Mar'},
                    {id: 3, name: 'Apr'},
                    {id: 4, name: 'May'},
                    {id: 5, name: 'Jun'},
                    {id: 6, name: 'Jul'},
                    {id: 7, name: 'Aug'},
                    {id: 8, name: 'Sep'},
                    {id: 9, name: 'Oct'},
                    {id: 10, name: 'Nov'},
                    {id: 11, name: 'Dec'}
                ],
                branchCode: '',
                finalQuery: '',
                spendToolkit: '',
                spendPhotofixr: '',
                spendEmails: '',
                spendBespoke: '',
                spendInstant: '',
                spend: {},
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                queryOptions: [],
                freetextQueryOptions: [],
                resourcePath: '/odata/OrderSearch?$filter=(status ne \'DRAFT\')+and+(status ne \'DELETED\')+and+(status ne \'CANCELLED\')+and+(status ne \'REJECTED\')+and+(source ne \'DELIVERY\')',
                lastOrders: []
            }
        },
        computed: {
            // month() {
            //     const currentMonthIndex = new Date().getMonth()
            //
            //     return this.months[currentMonthIndex]
            // }
        },
        created() {

            this.year = new Date().getFullYear();

            this.constructQueryString()
            this.constructMonthSummary()

            if (JSON.parse(window.sessionStorage.getItem('_role')).includes('AccountCustomer')) {
                this.branchCode = JSON.parse(window.sessionStorage.getItem('_customer')).ref
            } else {
                this.branchCode = 'ONLINE'
            }

        },
        mounted() {
            if (!JSON.parse(this.returnCookie("_customer")).customerName.includes('Winkworth')) {
                if (this.returnCookie("_messageShown") != 'True') {
                    document.getElementById("message").style.display = 'block';
                    window.sessionStorage.setItem("_messageShown", 'True')
                }
            }
        },
        methods: {
            constructMonthSummary() {

                try {
                    const pricing = `${process.env.VUE_APP_INSIGHTSAPIHOST}/api/v1/insights/order/GetNewSalesForBranch?Branch=` + JSON.parse(this.returnCookie("_customer")).ref + `&Month=` + Number(this.selectedMonth + 1) + `&Year=` + this.year

                    console.log(pricing)

                    Axios.get(pricing, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log(response)

                            this.spend = response.data

                            this.spendEmails = response.data.email
                            this.spendBespoke = response.data.bespoke
                            this.spendPhotofixr = response.data.photofixr
                            this.spendToolkit = response.data.toolkit
                            this.spendInstant = response.data.instantprint
                            // this.lastOrders = response.data.value
                        })
                        .catch(error => {
                            // this.lastOrders = []
                            // }
                        })

                } catch (error) {
                    console.log(error)
                }
            },
            constructQueryString() {

                this.queryOptions = []
                this.freetextQueryOptions = []

                let top5Orders = ''
                
                if (JSON.parse(this.returnCookie("_role")).includes('Customer')) {
                    top5Orders = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/customerSearchTopOrders?myCustomerRef=` + JSON.parse(this.returnCookie("_customer")).ref + '&top=' + this.topOrders
                } else {
                    top5Orders = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/customerSearchAdminTopOrders?top=` + this.topOrders
                }



                // try {
                //     this.finalQuery = ''
                //
                //     this.finalQuery = baseQueryUri.concat('+and+Branch in (\'' + JSON.parse(this.returnCookie("_customer")).ref + '\')&$orderby=Created desc&$top=5')
                // } catch (error) {
                //     todo catch logins without a customer object - this should just be admin users
                    // this.finalQuery = baseQueryUri.concat('&$orderby=Created desc&$top=5')
                // }



                // try {
                //     this.finalQuery = ''
                //
                //     this.finalQuery = baseQueryUri.concat('+and+Branch in (\'' + JSON.parse(this.returnCookie("_customer")).ref + '\')&$orderby=Created desc&$top=5')
                // } catch (error) {
                //     todo catch logins without a customer object - this should just be admin users
                    // this.finalQuery = baseQueryUri.concat('&$orderby=Created desc&$top=5')
                // }


                // this.freetextQueryOptions.push('Branch in (\'' + customer['ref'] + '\')&top=5')


                // this.finalQuery = ''
                //
                // this.finalQuery = baseQueryUri.concat('Branch in (\'' + JSON.parse(this.returnCookie("_customer")).ref + '\')&$orderby=Created desc&$top=5')

                // this.finalQuery = baseQueryUri.concat('select=Branch,Source,Created,OrderId,BillDescription&$Branch in (\'' + 'C260' + '\')&orderby=Created desc&$top=5')

                console.log(top5Orders)

                Axios.get(top5Orders, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.lastOrders = response.data.value
                    })
                    .catch(error => {
                        this.lastOrders = []
                        // }
                    })

            },
            viewOrder(order) {

                let uri = '';


                switch (order.source) {
                    case 'PDFUPLOAD':
                        uri = '/orders/instant-print'
                        break;
                    case 'TOOLKIT':
                        uri = '/orders/toolkit'
                        break;
                    case 'EMAIL':
                        uri = '/orders/email'
                        break;
                    case 'BESPOKE':
                        uri = '/orders/bespoke'
                        break;
                    case 'PHOTOFIXR':
                        uri = '/orders/photofixr'
                        break;
                    default:
                        uri = ''
                }

                Router.push({
                    name: uri,
                })
            },
            routeBillingAddress() {
                Router.push({
                    name: '/account/billing'
                });
            },
            routePassword() {
                Router.push({
                    name: '/account/reset-password'
                });
            },
            goToAllOrders() {
                Router.push({
                    name: '/orders/all'
                });
            },
            closeMessage() {
                document.getElementById("message").style.display = 'none';
            }
        }
    };
</script>